import React, { useEffect, useRef, useState } from "react";
import googleicon from '../../Assets/Images/googleicon.png';
import stripeicon from '../../Assets/Images/stripeImg.png';
import paymentsuccessIcon from '../../Assets/Images/paymentsuccess.png';
import { formatUSNumber, MakeAxiosRequest } from "../../utils/handler";
import { useForm, Controller } from "react-hook-form";
import { Link, useNavigate, useParams } from 'react-router-dom';
import StripeContainer from './StripeContainer';
import { Modal, Button } from 'react-bootstrap';
import Loader from "../../Components/loader/Loader";
const WebViewModal = ({ url, show, handleClose }) => {
    return (
        <Modal show={show} onHide={handleClose} size="lg" >
            <Modal.Header>
                <button
                    type="button"
                    className="close-btn"
                    onClick={handleClose}
                >
                    <span className="material-symbols-outlined">close</span>
                </button>
            </Modal.Header>
            <Modal.Body>
                <iframe
                    src={url}
                    title="WebView"
                    width="100%"
                    className="viewModal"
                    height="600px"
                    style={{ border: 'none' }}
                />
            </Modal.Body>

        </Modal>
    );
};
function SucessPayment() {
    const [isLoading, setIsLoading] = useState(true);
    const params = useParams();
    const [data, setData] = useState({});
    const [url, setUrl] = useState("");
    const [modalShow, setModalShow] = useState(false);
    useEffect(() => {
        fetchData();
    }, []);

       const handleShow = async() => {

            try {
                const response = await MakeAxiosRequest("post", "/genaratewebtoken",{key: params.key,type:"invoicedetails"});
                if (response.status == 1) {
                    setUrl(response.data.redirectUrl);
                    setModalShow(true);
                } else {
                    console.log(response);
                }
            } catch (error) {
                console.error("Error", error);
            }
                
        };

    const fetchData = async () => {
        try {
            const response = await MakeAxiosRequest("post", "/payment-success/" + params.key, { invoice_uuid: params.key });
            // console.log(response)
            if (response.status == 1) {
                setData(response.data);
                setIsLoading(false);
            } else {
                console.log(response);
            }
        } catch (error) {
            console.error("Error", error);
        }
    }
    const handleDownload = () => {

        if (data.downloadUrl) {
            // Create a Blob from the base64 string
            const byteCharacters = atob(data.downloadUrl);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });

            // Create a download link
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            link.setAttribute('download', data.invoiceID+ '.pdf'); // Customize the file name here
            document.body.appendChild(link);
            link.click();

            // Clean up
            link.remove();
            window.URL.revokeObjectURL(url);
            console.log('downloaded');
        }

    };

    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (
                <section className="wrapper-body payment-body success-wrapper">


                    <div className="container">
                        <div className="row py-5">
                            <div className="col-md-7 mx-auto">

                                <div className="card">
                                    <div className="card-body payment_body p-sm-5 p-3">
                                        
                                        <div className="text-center">
                                            <img src={paymentsuccessIcon} alt="Logo" className="img-fluid success-gif" />
                                            <h2 className="mt-4 fw-e-bold" >Payment Successful!</h2>

                                            <h6 className="fw-medium">You have made the payment to <span className="primary">{data.org_name}</span></h6>
                                        </div>

                                        <div className="row mt-4">

                                            <div className="col-12">
                                                <div className="invoice_inner">
                                                <div className="d-flex justify-content-between align-items-center">
                                                        <p>Invoice Number</p>
                                                        <h5 className="primary">{data.invoiceID}</h5>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center">

                                                        <p>Organization Name</p>
                                                        <h5>{data.org_name}</h5>
                                                    </div>
                                                   
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <p>Paid Date & Time</p>
                                                        <h5>{data.paymentDate}, {data.paymentTime}</h5>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center ">
                                                        <p>Sub Total</p>
                                                        <h6 className="primary fw-medium mb-0">{data.currencyLabel}{data.subtotal}</h6>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center ">
                                                        <p>{data.taxLabel}</p>
                                                        <h6 className="primary fw-medium mb-0">{data.currencyLabel}{data.taxamount}<span className="sm_text">{data.tax_percentage && ` (${data.tax_percentage}%)`}</span></h6>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center ">
                                                        <p>Total</p>
                                                        <h6 className="primary fw-medium mb-0">{data.currencyLabel}{data.total}</h6>
                                                    </div>
                                                    
                                                
                                                </div>
                                                <div className="btn_align justify-content-center mt-4 col-8 mx-auto">
                                                    {/* <Button className="btn btn-outline-primary w-100" variant="primary" onClick={() => handleShow()}>
                                                        Invoice Details
                                                    </Button> */}

                                                    <WebViewModal
                                                        url={url}
                                                        show={modalShow}
                                                        handleClose={() => setModalShow(false)}
                                                    />


                                                    <button className="btn btn-primary w-100" onClick={handleDownload}>Download Receipt</button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            )}
        </>
    )
}

export default SucessPayment